export const SAMPLE = "SAMPLE";
